
















import {Vue, Component} from 'vue-property-decorator';
import { stat, copyFile } from 'fs';

@Component
export default class Confirm extends Vue {
  public dialog: boolean = false;
    public  resolve: any = null;
    public  reject: any =  null;
    public  message: string = '';
    public  title: string = '';
     public options: any = {
        color: 'indigo',
        width: 290,
    };

    public open(title: string, message: string) {
        this.dialog = true;
        this.title = title;
        this.message = message;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      }

      public  agree() {
        this.resolve(true);
        this.dialog = false;
      }

      public  cancel() {
        this.resolve(false);
        this.dialog = false;
      }
}
